import { watchEffect } from 'vue';
import useI18nStore from '@/common/store/pinia/i18n';

function toShortLocale(locale: string): string {
  return locale.split('-')[0];
}

export function useL18nAdapterSync(adapter?: L18nAdapter): void {
  if (!adapter) return;

  const i18nStore = useI18nStore();

  watchEffect(() => {
    const rawLocale = adapter.locale.value;
    if (!rawLocale) return;
    i18nStore.loadLanguage(toShortLocale(rawLocale));
  });
}
